import ApiService from '../api.service';

const NfeResource = {
  send: (params) => ApiService.post('/v1/nfes', params),
  index: (params) => ApiService.query('/v1/nfes', params),
  fetchNfeToOffer: (params) => ApiService.query(`/v1/business/${params.business_id}/nfes`, params),
};

export default NfeResource;
